// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Message Page - Rich Text Content Styles */

.message-content p {
  margin-bottom: 1.5rem;
  line-height: 1.8;
}

.message-content p:last-child {
  margin-bottom: 0;
}

.message-content strong {
  font-weight: 700;
  color: #1e293b;
}

.message-content em {
  font-style: italic;
}

.message-content ul {
  list-style-type: disc;
  padding-left: 2rem;
  margin-bottom: 1.5rem;
}

.message-content ol {
  list-style-type: decimal;
  padding-left: 2rem;
  margin-bottom: 1.5rem;
}

.message-content li {
  margin-bottom: 0.5rem;
  line-height: 1.7;
}

.message-content h1 {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #1e293b;
}

.message-content h2 {
  font-size: 1.75rem;
  font-weight: 700;
  margin-bottom: 1.25rem;
  color: #1e293b;
}

.message-content h3 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #1e293b;
}

.message-content h4 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: #1e293b;
}

.message-content h5 {
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #1e293b;
}

.message-content h6 {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #1e293b;
}

.message-content a {
  color: #9b1c31;
  text-decoration: underline;
}

.message-content a:hover {
  color: #7a1628;
}

.message-content blockquote {
  border-left: 4px solid #9b1c31;
  padding-left: 1.5rem;
  margin: 1.5rem 0;
  font-style: italic;
  color: #64748b;
}

.message-content code {
  background-color: #f1f5f9;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-family: monospace;
  font-size: 0.875em;
}

.message-content pre {
  background-color: #f1f5f9;
  padding: 1rem;
  border-radius: 0.5rem;
  overflow-x: auto;
  margin: 1.5rem 0;
}

.message-content pre code {
  background: none;
  padding: 0;
}

/* Quill editor specific classes */
.message-content .ql-align-center {
  text-align: center;
}

.message-content .ql-align-right {
  text-align: right;
}

.message-content .ql-align-justify {
  text-align: justify;
}

.message-content .ql-size-small {
  font-size: 0.875rem;
}

.message-content .ql-size-large {
  font-size: 1.25rem;
}

.message-content .ql-size-huge {
  font-size: 1.5rem;
}

.message-content img {
  max-width: 100%;
  height: auto;
  margin: 1.5rem 0;
  border-radius: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/MessagePage.css"],"names":[],"mappings":"AAAA,4CAA4C;;AAE5C;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB","sourcesContent":["/* Message Page - Rich Text Content Styles */\n\n.message-content p {\n  margin-bottom: 1.5rem;\n  line-height: 1.8;\n}\n\n.message-content p:last-child {\n  margin-bottom: 0;\n}\n\n.message-content strong {\n  font-weight: 700;\n  color: #1e293b;\n}\n\n.message-content em {\n  font-style: italic;\n}\n\n.message-content ul {\n  list-style-type: disc;\n  padding-left: 2rem;\n  margin-bottom: 1.5rem;\n}\n\n.message-content ol {\n  list-style-type: decimal;\n  padding-left: 2rem;\n  margin-bottom: 1.5rem;\n}\n\n.message-content li {\n  margin-bottom: 0.5rem;\n  line-height: 1.7;\n}\n\n.message-content h1 {\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 1.5rem;\n  color: #1e293b;\n}\n\n.message-content h2 {\n  font-size: 1.75rem;\n  font-weight: 700;\n  margin-bottom: 1.25rem;\n  color: #1e293b;\n}\n\n.message-content h3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  color: #1e293b;\n}\n\n.message-content h4 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 0.75rem;\n  color: #1e293b;\n}\n\n.message-content h5 {\n  font-size: 1.125rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: #1e293b;\n}\n\n.message-content h6 {\n  font-size: 1rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: #1e293b;\n}\n\n.message-content a {\n  color: #9b1c31;\n  text-decoration: underline;\n}\n\n.message-content a:hover {\n  color: #7a1628;\n}\n\n.message-content blockquote {\n  border-left: 4px solid #9b1c31;\n  padding-left: 1.5rem;\n  margin: 1.5rem 0;\n  font-style: italic;\n  color: #64748b;\n}\n\n.message-content code {\n  background-color: #f1f5f9;\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n  font-family: monospace;\n  font-size: 0.875em;\n}\n\n.message-content pre {\n  background-color: #f1f5f9;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  overflow-x: auto;\n  margin: 1.5rem 0;\n}\n\n.message-content pre code {\n  background: none;\n  padding: 0;\n}\n\n/* Quill editor specific classes */\n.message-content .ql-align-center {\n  text-align: center;\n}\n\n.message-content .ql-align-right {\n  text-align: right;\n}\n\n.message-content .ql-align-justify {\n  text-align: justify;\n}\n\n.message-content .ql-size-small {\n  font-size: 0.875rem;\n}\n\n.message-content .ql-size-large {\n  font-size: 1.25rem;\n}\n\n.message-content .ql-size-huge {\n  font-size: 1.5rem;\n}\n\n.message-content img {\n  max-width: 100%;\n  height: auto;\n  margin: 1.5rem 0;\n  border-radius: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
